import script from "./ConfirmationOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationOverlay.vue?vue&type=style&index=0&id=0d3fab13&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3fab13"]])

export default __exports__